import { gql } from "@/__generated__/gql";

export const RISE_MELT_INDEX_SUMMARY = gql(`
query riseMeltIndexSummary($orgId: ID!, $cohortYear: Int!, $inCommunity: YesNoEnum) {
  node(id: $orgId) {
    id
    ... on Organization {
      rise {
        meltIndexSummary(cohortYear: $cohortYear, inCommunity: $inCommunity) {
          low {
            state
            value
          }
          mediumLow {
            state
            value
          }
          medium {
            state
            value
          }
          mediumHigh {
            state
            value
          }
          high {
            state
            value
          }
        }
      }
    }
  }
}
`);
